(function () {
  'use strict';

  angular.module('app').component('productAssociatedProviders', productAssociatedProviders());

  function productAssociatedProviders() {
    return {
      bindings: {
        product: '<',
        productType: '@',
        viewMode: '<',
        associatedProviders: '=',
        defaultProviderId: '=', // Important
        onAssociatedProviderSaved: '&',
        onAssociatedProviderDeleted: '&',
        onSelectedTab: '&',
        defaultLanguage: '<',
      },
      controller: ProductAssociatedProvidersComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/components/product-associated-providers/product-associated-providers.component.html',
    };
  }

  ProductAssociatedProvidersComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ProviderService',
    'TourService',
    'TransportationService',
    'HotelService',
    'ServiceItemService',
    'ServiceItemCostService',
    'PackageService',
  ];

  function ProductAssociatedProvidersComponent(
    config,
    UtilService,
    ProviderService,
    TourService,
    TransportationService,
    HotelService,
    ServiceItemService,
    ServiceItemCostService,
    PackageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    var fieldsDefinition = ['provider_product_code'];

    // Methods
    vm.addAssociatedProvider = addAssociatedProvider;
    vm.editAssociatedProvider = editAssociatedProvider;
    vm.removeAssociatedProvider = removeAssociatedProvider;
    vm.changeAssociatedProviderStatus = changeAssociatedProviderStatus;
    vm.deleteAssociatedProvider = deleteAssociatedProvider;
    vm.updateCostAndPrices = updateCostAndPrices;
    vm.setDefaultAssociatedProvider = setDefaultAssociatedProvider;
    vm.saveAssociatedProvider = saveAssociatedProvider;

    vm.openProviderInfoModal = openProviderInfoModal;
    vm.openProviderFastCreate = openProviderFastCreate;
    vm.selectProvider = selectProvider;

    vm.openProviderCostsModal = openProviderCostsModal;

    vm.$onInit = function () {
      vm.productCopy = angular.copy(vm.product); //!important as the object was modified in other component
    };

    function addAssociatedProvider() {
      vm.addMode = true;
      vm.associatedProviders.push({ status: true });
    }

    function editAssociatedProvider(associatedProvider) {
      associatedProvider.editMode = !associatedProvider.editMode;

      if (!associatedProvider.editMode) {
        // Undo changes
        _restoreOriginalValues(associatedProvider);
      } else {
        // save server name to restore it if the user cancel edition
        associatedProvider.originalValues = angular.toJson(associatedProvider);
      }
    }

    function _restoreOriginalValues(associatedProvider) {
      var serverItem = angular.fromJson(associatedProvider.originalValues);

      fieldsDefinition.forEach(function (field) {
        associatedProvider[field] = serverItem[field];
      });
    }

    function removeAssociatedProvider(index) {
      vm.addMode = false;
      vm.associatedProviders.splice(index, 1);
    }

    function changeAssociatedProviderStatus(associatedProvider) {
      ProviderService.changeAssociatedProviderStatus(
        associatedProvider,
        associatedProvider.provider_id
      );
    }

    function deleteAssociatedProvider(associatedProvider) {
      //index
      var successCallback = function () {
        //index
        var index = vm.associatedProviders.indexOf(associatedProvider); // To work with orderBy

        removeAssociatedProvider(index);

        vm.onAssociatedProviderDeleted({ items: vm.associatedProviders });
      };

      ProviderService.deleteAssociatedProvider(
        associatedProvider,
        associatedProvider.provider_id,
        successCallback
      ); // , index
    }

    function updateCostAndPrices() {
      vm.onSelectedTab({ tab: 5 });
    }

    function setDefaultAssociatedProvider(associatedProvider) {
      var successCallback = function (providerId) {
        vm.defaultProviderId = providerId;
        vm.product.default_provider_id = providerId;
      };

      switch (vm.productType) {
        case 'tour':
          TourService.setDefaultAssociatedProvider(
            associatedProvider.provider_id,
            vm.product.id,
            successCallback
          );
          break;
        case 'transportation':
          TransportationService.setDefaultAssociatedProvider(
            associatedProvider.provider_id,
            vm.product.id,
            successCallback
          );
          break;
        case 'hotel':
          HotelService.setDefaultAssociatedProvider(
            associatedProvider.provider_id,
            vm.product.id,
            successCallback
          );
          break;
        case 'service_item':
          ServiceItemService.setDefaultAssociatedProvider(
            associatedProvider.provider_id,
            vm.product.id,
            successCallback
          );
          break;
        case 'package':
          PackageService.setDefaultAssociatedProvider(
            associatedProvider.provider_id,
            vm.product.id,
            successCallback
          );
          break;
      }
    }

    // Create/Update
    function saveAssociatedProvider(associatedProvider, isFormValid) {
      associatedProvider.serverErrors = [];

      if (isFormValid) {
        if (!associatedProvider.editMode) {
          // Create
          associatedProvider.product_type = vm.productType;
          associatedProvider[vm.productType + '_id'] = vm.product.id;
        }

        var item = {
          id: associatedProvider.id,
          product_type: associatedProvider.product_type,
          [vm.productType + '_id']: associatedProvider[vm.productType + '_id'],
          provider_product_code: associatedProvider.provider_product_code,
          provider_id: associatedProvider.provider_id,
        };

        vm.sendingForm = true;
        ProviderService.saveAssociatedProvider(item, associatedProvider.provider_id).then(function (
          data
        ) {
          if (!data.errors) {
            // !important as we are sending a item object
            associatedProvider.id = data.id;
            associatedProvider.status = data.status;
            associatedProvider.product = data.product;
            associatedProvider.provider = data.provider;

            vm.associatedProviders = vm.associatedProviders.sort((a, b) =>
              a.name < b.name ? 1 : -1
            );

            vm.onAssociatedProviderSaved({ product: data.product, items: vm.associatedProviders });

            associatedProvider.editMode = false;
            delete associatedProvider.originalValues;
          } else {
            associatedProvider.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
          }

          vm.addMode = false;
          vm.sendingForm = false;
        });
      }
    }

    // For service item only
    function openProviderCostsModal(associatedProvider) {
      let successCallback = (dataObj) => {
        associatedProvider.product.current_costs = {
          rates_today: dataObj.rates_today,
          rates_updated_until: dataObj.rates_updated_until,
          currency: dataObj.currency,
        };
      };

      ServiceItemCostService.openServiceItemCostsModal(
        vm.productCopy,
        associatedProvider.provider,
        'provider',
        vm.defaultLanguage,
        successCallback
      );
    }

    function openProviderInfoModal(provider) {
      ProviderService.openProviderInfoModal(provider);
    }

    function openProviderFastCreate(associatedProvider) {
      const successCallback = function (provider) {
        selectProvider(provider, associatedProvider);
      };

      ProviderService.openProviderFastCreate({}, successCallback);
    }

    vm.searchProvider = function (value, associatedProvider) {
      associatedProvider.provider_id = null;

      const params = {
        get: 'active',
        by_provider: value,
        skip_check_role: true,
      };

      return ProviderService.getProviders(params).then(function (data) {
        if (data.items.length === 0) {
          associatedProvider.provider_id = null;
        }

        return data.items;
      });
    };

    function selectProvider(provider, associatedProvider) {
      associatedProvider.provider = provider;
      associatedProvider.provider_id = provider.id;
    }
  }
})();
